import permission_api from '../../api/permissions'
import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

function handlePermissionsLoaded(context, permissions) {
    context.commit(mutation_types.PERMISSION_SET, permissions)
    context.commit(mutation_types.SET_BENCHMARK_FREEMIUM_ENABLED, !!permissions.list.freemium_results_benchmark)
}

const state = {
  permissions: {}
}
const actions = {
    [action_types.PERMISSION_LOAD] (context) {
        permission_api.getPermissions({}, permissions => handlePermissionsLoaded(context, permissions));
    }
}
const mutations = {
    [mutation_types.PERMISSION_SET] (state, permissions) {state.permissions = permissions},
}

export default {state, actions, mutations}
